// bg control
/* control: {
    bg: {
        fadeIn: null,
        fadeOut: null,
        setColor: null,
        fadeColor: null,
    }
},
f: {
    bg: {
        calc: null
    }
}, */


page.three.control.bg.fadeIn = function(t){
    if(typeof(t) != "number") t = 1000;
    var v = page.three.v.bg;
    v.aTarget = 1;
    v.aStep = 1/t;
    v.aVal = page.three.bgMat.uniforms.alpha.value;
}
page.three.control.bg.fadeOut = function(t){
    if(typeof(t) != "number") t = 1000;
    var v = page.three.v.bg;
    v.aTarget = 0;
    v.aStep = -1/t;
    v.aVal = page.three.bgMat.uniforms.alpha.value;
}

page.three.control.bg.setColor = function(c){
    if(typeof(c) != "number") return;
    var v = page.three.v.bg;
    c = Math.clamp(c, 0, 1);
    v.cTarget = c;
    v.cVal = 1;
    page.three.bgMat.uniforms.phase.value = c;
    page.three.v.bgDone = true;
}

page.three.control.bg.fadeColor = function(c, t){
    page.three.v.bgDone = false;
    page.three.v.alwaysRender = true;
    log.webgl("FadeBg: START");

    if(typeof(c) != "number") return // todo fix
    if(typeof(t) != "number") t = 1000;
    c = Math.clamp(c, 0, 1);
    var v = page.three.v.bg;

    v.cStart = page.three.bgMat.uniforms.phase.value;
    v.cTarget = c;
    v.cVal = 0;
    v.cStep = 1 / t;
}

page.three.f.bg.calc = function(){
    var t=page.v.time;
    var v = page.three.v.bg;
    var a = page.three.bgMat.uniforms.alpha;

    if(v.aVal != v.aTarget){
        v.aVal += v.aStep * t.delta;
        //if(Math.abs(v.aTarget - v.aVal) <= Math.abs(v.aStep) || Math.sign(v.aStep)) v.aVal = v.aTarget;
        v.aVal = Math.clamp(v.aVal, 0, 1);
        //a.value = Math.sin(Math.PI/2 * v.aVal);
        a.value = Math.ease.inOutSin(v.aVal);
    }
    if(v.cVal != 1){
        v.cVal += v.cStep * t.delta;
        v.cVal = Math.clamp(v.cVal, 0, 1);
        if(v.cVal >= 1){
            page.three.bgMat.uniforms.phase.value = v.cTarget;
        }else{
            page.three.bgMat.uniforms.phase.value = THREE.Math.lerp(v.cStart, v.cTarget, Math.ease.outSin(v.cVal));
        }
    }else if(!page.three.v.bgDone){
        log.webgl("FadeBg: DONE");
        page.three.v.bgDone = true;
    }
}